import { Injectable } from '@angular/core';
import { DatePickerService } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root'
})
export class CustomDatepickerService extends DatePickerService {
  override get placeholder(): string {
    return super.placeholder;
  }

  override get pattern(): string {
    return super.pattern;
  }

  override isValidFormat(date: string, pattern?: string): boolean {
    return super.isValidFormat(date, pattern);
  }
}
